// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Pencil(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Pencil" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M15.0082 5.77182L3 17.78V21L6.21996 20.9999L18.2282 8.99177L15.0082 5.77182Z", fill: "currentColor" }),
            React.createElement("path", { d: "M17.2589 3.5211L16.2157 4.56434L19.4357 7.7843L20.4789 6.74106C21.1458 6.07418 21.1767 5.02389 20.548 4.39515L19.6048 3.45205C18.9761 2.82331 17.9258 2.85423 17.2589 3.5211Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Pencil.js.map